import React from 'react';

function ColorCountSelect(props) {
  return (
    <section className="color-count-select">
      <h2>Izvēlies krāsu skaitu:</h2>
      <form className="color-count-select__form" onChange={props.onChange}>
        <label htmlFor="color-count-select__input--6" className="color-count-select__label">
          <input
            id="color-count-select__input--6"
            type="radio"
            value="6"
            name="colorCount"
            className="color-count-select__input"
            defaultChecked={props.colorCount === 6}
          /> 6 krāsas
        </label>
        <label htmlFor="color-count-select__input--12" className="color-count-select__label">
          <input
            id="color-count-select__input--12"
            type="radio"
            value="12"
            name="colorCount"
            className="color-count-select__input"
            defaultChecked={props.colorCount === 12}
          /> 12 krāsas
        </label>
      </form>
    </section>
  );
}

export default ColorCountSelect;



// WEBPACK FOOTER //
// ./src/components/colorCountSelect.js